/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { ReservationState } from '../state/ReservationState'
import ReservationEvent from '../../event/ReservationEvent'

class ReservationStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.fetchOne:
        return state.mergeModel(payload.reservation)

      case ReservationEvent.onEdit:
        if (payload.name === 'status') {
          return state.setStatus(payload.value)
        }
        return state.set(payload.name, payload.value)

      case ReservationEvent.startCreation:
        return state.clear().merge({
          accommodation_fee: 0,
          num_adult: 1,
          num_child: 0
        })
      case ReservationEvent.cancelCreation:
      case ReservationEvent.hideDetail:
        return state.clear()

      case ReservationEvent.onUpdateReservationPay:
        return state.merge({
          is_paid_accommodation_fee: payload.reservation_pay.accommodation_fee_paid,
          is_paid_accommodation_tax: payload.reservation_pay.accommodation_tax_paid
        })

      case ReservationEvent.onUpdateNoshow:
        return state.merge({ noshow: payload.noshow })

      default:
        return state
    }
  }
}

export default new ReservationStore()
